import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {PhotoData} from '@employee-pages/badge-request-page/employee-badge-requests';


@Component({
  selector: 'employee-take-photo-desktop',
  templateUrl: './employee-take-photo-desktop.component.html',
  styleUrls: ['./employee-take-photo-desktop.component.less']
})
export class EmployeeTakePhotoDesktopComponent {

    @Input() userCanTakePhoto = true;
    @Input() canUseCurrentImage: boolean;
    @Input() photoData: PhotoData;
    @Input() userPhotoUrl: string = null;
    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() uploadConfig: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() cameraConfig: EmployeeModels.DM.IBadgeRequestInfoEmployee;

    @Output() onTakePhoto = new EventEmitter<PhotoData>();
    @Output() onDelete = new EventEmitter<void>();
    @Output() onUseCurrentPhoto = new EventEmitter<PhotoData>();
    @Output() onUpload = new EventEmitter<PhotoData>();

    @Input() newFileName: string = null;

    // Photo only available only for employees
    isVisitorRequest = false;


    onPhotoTaken(event: PhotoData): void {
        this.onTakePhoto.emit(event);
    }

    deletePhoto(): void {
        this.onDelete.emit();
    }

    useCurrentPhoto(): void {
        this.onUseCurrentPhoto.emit();
    }

    onPhotoUploaded(event: PhotoData[]): void {
        this.onUpload.emit(event[0]);
    }

}
